import { render } from "./SearchInput.vue?vue&type=template&id=5ed1b08a"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"
script.render = render

export default script